import readCookie from './readCookie';

const authToken = (): string => readCookie('auth_token');
export default authToken;

export const authorizationHeader = (token = authToken()): string => `Bearer ${token}`;

export const userId = (): string => readCookie('user_id');
